import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getUser } from 'Actions/users';
import Auth from '../../../../Auth';
import css from './ProfileCard.APP_TARGET.scss';
import { Link } from 'react-router-dom';
import { Avatar } from 'panamera-react-ui';
import withTrack from 'HOCs/withTrack/withTrack';
import ContactInfo from './ContactInfo.APP_TARGET';
import setLoginModalState from 'Actions/setLoginModalState';
import { injectIntl } from 'react-intl';
import MemberSince from 'Components/MemberSince/MemberSince';
import { adStatus } from 'Constants/adStatus';
import withReplyRestriction from 'HOCs/withReplyRestriction/withReplyRestriction';
import withDirection from 'HOCs/withDirection/withDirection';
import { PROFILE_SHOW } from 'Constants/tracking';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import { TrackerOrigins } from 'Components/TrackerProvider/TrackerProvider';
import { isMobile } from 'Helpers/devices';
import classnames from 'classnames';
import { checkIfMxCL } from '../../../../../app/autos/helpers/helpers';

export class ProfileCard extends React.Component {
    static propTypes = {
        avatar: PropTypes.string,
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        isMyItem: PropTypes.bool,
        toggleFirstTimeUserTips: PropTypes.func.isRequired,
        itemUserId: PropTypes.string.isRequired,
        onTrack: PropTypes.func.isRequired,
        track: PropTypes.func.isRequired,
        getTrackingInfo: PropTypes.func.isRequired,
        trackerOrigins: PropTypes.object,
        onMessageSend: PropTypes.func.isRequired,
        tipsInitiationPoint: PropTypes.string,
        user: PropTypes.object,
        itemStatus: PropTypes.object,
        intl: PropTypes.object.isRequired,
        buttonContactType: PropTypes.string,
        withViewProfileButton: PropTypes.bool,
        leadFormName: PropTypes.string,
        leadFormFlow: PropTypes.func,
        isReplyRestricted: PropTypes.func,
        itemId: PropTypes.string,
        direction: PropTypes.oneOf(['ltr', 'rtl']).isRequired,
        showCall: PropTypes.bool,
        showChat: PropTypes.bool,
        showInterest: PropTypes.bool,
        showCallRequest: PropTypes.bool,
        showSeePhoneNumber: PropTypes.bool,
        showMakeOffer: PropTypes.bool,
        showWhatsAppCTA: PropTypes.bool,
        showTestDrive: PropTypes.bool,
        config: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired,
        showNib: PropTypes.bool,
        nibNumber: PropTypes.string,
        ctaConfigSetup: PropTypes.object,
        primaryCTA: PropTypes.string
    };

    static defaultProps = {
        avatar: '',
        isMyItem: false,
        setLoginModalState: () => {},
        tipsInitiationPoint: '',
        user: {},
        itemStatus: {},
        buttonContactType: 'outline',
        withViewProfileButton: false,
        leadFormName: '',
        leadFormFlow: () => {},
        isReplyRestricted: () => {},
        itemId: '',
        showCall: false,
        showChat: false,
        showInterest: false,
        showCallRequest: false,
        showSeePhoneNumber: false,
        showMakeOffer: false,
        showTestDrive: false,
        showNib: false
    };

    constructor(props) {
        super(props);

        this.userLogged = Auth.getUser();

        this.translations = {
            sellerDescription: { id: 'sellerDescription' },
            viewprofile: { id: 'viewprofile' }
        };
        this.isClassified = !checkIfMxCL(props.config);
    }

    onClickProfile = () => this.props.track(PROFILE_SHOW, {
        ...this.props.getTrackingInfo(),
        origin: TrackerOrigins.VIEW_ITEM,
        select_from: 'other_profile'
    });

    // modern design for letgo
    getModernDesign = () => {
        if (this.isClassified) {
            return !isMobile;
        }
        return true;
    }

    render() {
        let profileUrl = '';
        const { itemStatus, user, withViewProfileButton, direction, showNib } = this.props;
        const showCtas = itemStatus && itemStatus.status === adStatus.ACTIVE;

        if (this.userLogged && this.userLogged.id === this.props.id) {
            profileUrl = '/profile';
        }
        else {
            profileUrl = `/profile/${this.props.id}`;
        }
        return (
            <div className={ classnames(css.profileContainer,
                { [css.modernContainer]: this.isClassified }
            ) }>
                { !(this.props.isMyItem || this.isClassified) && (
                    <div data-aut-id="profileTitle" className={ css.cardTitle }>
                        { this.props.intl.formatMessage(this.translations.sellerDescription) }
                    </div>
                )}
                {/* <div className={ css.profileCard } data-aut-id="profileCard">
                    <Link title="avatar" to={ profileUrl } rel="nofollow" onClick={ this.onClickProfile } className={ css.avatarWrapper }>
                        <Avatar image={ this.props.avatar } diameter="68px" className={ css.avatar } />
                    </Link>
                    <div className={ css.profileData }>
                        <Link title={ this.props.name } to={ profileUrl } rel="nofollow" onClick={ this.onClickProfile }>
                            <div className={ css.profileTitle } >{this.props.name}</div>
                            <span className={ css.arrow }>
                                <Icon icon="arrowRight" direction={ direction } size={ 18 } />
                            </span>
                            { this.getModernDesign() && withViewProfileButton && this.props.intl.formatMessage(this.translations.viewprofile) }
                        </Link>
                        {!this.isClassified && <div className={ css.memberSince }>
                            <MemberSince user={ user } />
                        </div>}
                    </div>
                </div> */}
                <div className={ css.profileCard } data-aut-id="profileCard">
                    <Link title="avatar" to={ profileUrl } rel="nofollow" onClick={ this.onClickProfile } className={ css.avatarWrapper }>
                        <Avatar image={ this.props.avatar } diameter="68px" className={ css.avatar } />
                    </Link>
                    <div className={ css.profileData }>
                        <Link title={ this.props.name } to={ profileUrl } rel="nofollow" onClick={ this.onClickProfile }>
                            <div className={ css.profileTitle } >{this.props.name}</div>
                            { (isMobile && showNib)
                            && <div className={ css.nibNumber }>
                                <div>
                                    { this.props.intl.formatMessage({ id: 'nibText' })}
                                </div>
                                <div>
                                    {this.props?.nibNumber}
                                </div>
                            </div>}
                            <span className={ css.arrow }>
                                <Icon icon="arrowRight" direction={ direction } size={ 18 } />
                            </span>
                            { this.getModernDesign() && withViewProfileButton && this.props.intl.formatMessage(this.translations.viewprofile) }
                        </Link>
                        {!this.isClassified && <div className={ css.memberSince }>
                            <MemberSince user={ user } />
                        </div>}
                    </div>
                </div>

                <ContactInfo
                    showCtas={ showCtas }
                    toggleFirstTimeUserTips={ this.props.toggleFirstTimeUserTips }
                    onMessageSend={ this.props.onMessageSend }
                    tipsInitiationPoint={ this.props.tipsInitiationPoint }
                    onTrack={ this.props.onTrack }
                    leadFormName={ this.props.leadFormName }
                    leadFormFlow={ this.props.leadFormFlow }
                    trackerOrigins={ this.props.trackerOrigins }
                    buttonContactType={ this.props.buttonContactType }
                    itemId={ this.props.itemId }
                    itemUserId={ this.props.itemUserId }
                    isReplyRestricted={ this.props.isReplyRestricted }
                    userId={ this.userLogged && this.userLogged.id }
                    showTestDrive={ this.props.showTestDrive }
                    showSeePhoneNumber={ this.props.showSeePhoneNumber }
                    showCallRequest={ this.props.showCallRequest }
                    showInterest={ this.props.showInterest }
                    showChat={ this.props.showChat }
                    showCall={ this.props.showCall }
                    showMakeOffer={ this.props.showMakeOffer }
                    showWhatsAppCTA={ this.props.showWhatsAppCTA }
                    ctaConfigSetup={ this.props.ctaConfigSetup }
                    primaryCTA={ this.props.primaryCTA }
                />
            </div>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    getUser: userId => dispatch(getUser(userId, true)),
    setLoginModalState: state => dispatch(setLoginModalState(state))
});

export const mapStateToProps = (state, props) => {
    const item = state.items.elements[props.itemId];
    const user = (item && state.users.elements[props.itemUserId]);

    return {
        item,
        user
    };
};

export default compose(
    withTrack,
    injectIntl,
    withReplyRestriction,
    withDirection,
    connect(mapStateToProps, mapDispatchToProps)
)(ProfileCard);
